/**
 * Frontend version — bump on every feature/hotfix branch so atlas-tracked
 * deploys show the correct shipped version.
 */
export const VERSION = '0.29.1'; // hotfix-1-1: creative library lineages newest-first + Updated date on card
